module.exports = __webpack_public_path__ + "static/media/welcome_to_all3d.6ae5b273.jpg";